// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZqPvo","largestCol":"styles_largestCol__3Qno5","smallestCol":"styles_smallestCol__2c2fs"};